import { useCallback, useLayoutEffect, useState } from 'react';
import { initialTheme, type Theme, writeStoredTheme } from './theme-storage';

const LIGHT_CLASS = 'au-light';

/**
 * El tema de `@au` vive como clase en `document.documentElement` (no en `au-scope`): Base UI portalea
 * los popups al `body` y tienen que heredar la paleta. El cleanup quita la clase, así que al
 * desmontarse quien llama al hook (la rama fsd) el resto del producto sigue oscuro.
 */
export function useDocumentTheme(): { theme: Theme; toggle: () => void } {
  const [theme, setTheme] = useState<Theme>(initialTheme);

  useLayoutEffect(() => {
    const root = document.documentElement;
    root.classList.toggle(LIGHT_CLASS, theme === 'light');
    return () => root.classList.remove(LIGHT_CLASS);
  }, [theme]);

  // `next` se calcula y se guarda fuera del updater de `setTheme`: los updaters tienen que ser puros
  // (StrictMode los invoca dos veces).
  const toggle = useCallback(() => {
    const next: Theme = theme === 'light' ? 'dark' : 'light';
    writeStoredTheme(next);
    setTheme(next);
  }, [theme]);

  return { theme, toggle };
}
